import {
  brandOptions,
  cityOptions,
  eventOptions,
  eventTypeOptions,
  getOption,
  contractFileOptions,
  downloadFileOptions,
  industryCategoryOptions,
  dataStatusOptions
} from "@utils/zerone-options";
import parseISO from 'date-fns/parseISO'
import isValid from 'date-fns/isValid'
import formatDate from '@utils/format-date'

/**
 * 取得預設品牌
 * @param query
 * @returns {string}
 */
export function getDefaultBrand(query,brand = []) {
  return getOption({
    options: brandOptions(brand),
    value: query,
    key: 'value'
  })
}

/**
 * 取得預設縣市
 * @param query
 * @returns {string}
 */
export function getDefaultCity(query,city = []) {
  return getOption({
    options: cityOptions(city),
    value: query,
    key: 'value'
  })
}

/**
 * 取得預設課程類別
 * @param query
 * @returns {string}
 */
export function getDefaultMonth(query) {
  return query && isValid(parseISO(query))
    ? formatDate(`${ query }-01`, 'yyyy-MM')
    : ''
}

/**
 * 取得預設課程分類
 * @param query
 * @returns {string}
 */
export function getDefaultEvent(query) {
  return getOption({
    options: eventOptions(),
    value: query,
    key: 'value'
  })
}

/**
 * 取得預設課程類別
 * @param query
 * @returns {string}
 */
export function getDefaultEventType(query) {
  return getOption({
    options: eventTypeOptions(),
    value: query,
    key: 'value'
  })
}

/**
 * 取得預設BOT檔案類別
 * @param query
 * @returns {string}
 */
export function getDefaultContractFile(query) {
  return getOption({
    options: contractFileOptions(),
    value: query,
    key: 'value'
  })
}

/**
 * 取得預設檔案
 * @param query
 * @returns {string}
 */
export function getDefaultDownloadFile(query) {
  return getOption({
    options: downloadFileOptions(),
    value: query,
    key: 'value'
  })
}

/**
 * 取得預設檔案
 * @param query
 * @param category
 * @returns {string}
 */
export function getDefaultIndustryCategory(query,category = []) {
  return getOption({
    options: industryCategoryOptions(category),
    value: query,
    key: 'value'
  })
}

/**
 * 取得資料排序狀態
 * @param query
 * @returns {string}
 */
 export function getDefaultDataStatusOptions(query) {
  return getOption({
    options: dataStatusOptions(),
    value: query,
    key: 'value'
  })
}

